import { useAppTour } from "@/hooks/useAppTour";

/**
 * AppTourLauncher Component
 *
 * Component that handles auto-launching the app overview tour.
 * This component doesn't render anything visible - it just manages tour lifecycle.
 */
export function AppTourLauncher() {
  useAppTour();
  return null;
}
